import { SxProps, Avatar } from '@mui/material';
import React from 'react';
import {
  getAvatarStyleByIndex,
  getAvatarStyleByAlphabet,
} from 'utilities/avatar.helper';
import { getUserInitials } from 'utilities/utilityFunctions';

interface IUserAvatar extends React.HTMLAttributes<HTMLSpanElement> {
  employeeFullName: string;
  className?: string;
  index?: number;
  avatarSxProps?: SxProps;
}

const UserAvatar: React.FC<IUserAvatar> = ({
  employeeFullName,
  index,
  avatarSxProps,
  className = 'kfic2-metadata',
  ...rest
}) => {
  return (
    <Avatar
      className={className}
      sx={{
        borderRadius: '50%',
        display: 'flex',
        flexShrink: 0,
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 700,
        lineHeight: '1rem !important',
        ...getAvatarStyleByIndex(index ?? 0),
        ...getAvatarStyleByAlphabet(employeeFullName),
        ...avatarSxProps,
      }}
      aria-label={employeeFullName ? employeeFullName : 'User avatar'}
      {...rest}
    >
      {getUserInitials(employeeFullName)}
    </Avatar>
  );
};

export default UserAvatar;
